import { DnrModel } from "src/app/models/dnr/dnr.model";

export interface DnrState
{
    models: Record<string, DnrModel>;
}

export const DNR_FEATURE_KEY = 'dnr';